import React from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import Button from "../../Button";
import Manual from "./Manual";

const ManualModal = props => {
  return <Modal isOpen className="modal-w-md-100 height-100vh" size={'xl'} toggle={props.onClose}>
    <ModalHeader toggle={props.onClose}>{props?.itemMp?.ItemMpText}</ModalHeader>
    <ModalBody>
      <Manual
        itemMp={props.itemMp}
        manualId={props.manualId}
      />
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={props.onClose}>Zamknij</Button>
    </ModalFooter>
  </Modal>;
};

ManualModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  manualId: PropTypes.number,
  itemMp: PropTypes.shape({
    ItemMpText: PropTypes.string.isRequired,
    Manuals: PropTypes.arrayOf(PropTypes.shape({
      ManualId: PropTypes.number.isRequired,
      QualColId: PropTypes.string.isRequired,
      QualColText: PropTypes.string.isRequired,
    }),),
  }),
};

export default ManualModal;